import { render, staticRenderFns } from "./sid2token.vue?vue&type=template&id=56210986&"
import script from "./sid2token.vue?vue&type=script&lang=js&"
export * from "./sid2token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports